namespace advisorop.services {
  `use strict`;

    export class AdvisorService {

        // item and level from Household Summary Grid 
        selHDItem: any;
        selHDLevel: string = "";

        static $inject = [`$http`, `$q`];
        constructor(private $http: ng.IHttpService, private $q: ng.IQService) {
        }

        replaceSlashes(str: string): string {
            var ret: string = str;
            if (ret != null)
                ret = str.replace(/\/|\\/g, "-");
            return ret;
        }

        setAdminMode(adminMode: domains.IAdminMode): void {
            localStorage.setItem("adminMode", JSON.stringify(adminMode));
        }
        getAdminMode(): domains.IAdminMode {
            let adminMode: domains.IAdminMode = {};
            if (localStorage.getItem("adminMode")) {
                adminMode = JSON.parse(localStorage.getItem("adminMode"));
            }
            return adminMode;
        }
        isAdminModeEnabled(): boolean {
            let adminMode = this.getAdminMode();
            return (!!adminMode.enabled && !!adminMode.advisoryFirm && (adminMode.advisoryFirm.id > 0));
        }

        // #region Accounts
        getAccountForPost(account: domains.IAccount): domains.IAccount {
            let tmp: domains.IAccount = {};
            angular.copy(account, tmp);
            // Rows of the advisor accounts list (getaccounts) carry no investors.
            if (tmp.investors) {
                for (var i = 0; i < tmp.investors.length; i++) {
                    tmp.investors[i].companyGroup = null;
                    tmp.investors[i].systemLogin = null;
                }
            }
            tmp.advisoryFirm = null;
            return tmp;
        }
        getAccountsByAdvisor(accountStatus: number, showClosedAccounts: boolean, withAUM: boolean, withAdvisors: boolean, accountsFilter?: domains.IAccountFilter): ng.IHttpPromise<Array<domains.IAccount>> {
            var filter: string = null;
            if (accountsFilter != null)
                filter = JSON.stringify(accountsFilter);

            //console.log("ACCOUNTSFILTER:", accountsFilter);
            //console.log("FILTERPARAM", filter);

            return this.$http.get(`/api/advisor/getaccounts/` + accountStatus + `/` + showClosedAccounts + `/` + withAUM + '/' + withAdvisors + '/' + filter);
        };
        getUnmappedAccounts(syncWithPp: boolean = false): ng.IHttpPromise<Array<domains.IBOUnmappedAccount>> {
            return this.$http.get(`/api/advisor/getunmappedaccounts/${syncWithPp}`);
        };
        getUnmappedAccount(unmappedAccountId: number): ng.IHttpPromise<domains.IBOUnmappedAccount> {
            return this.$http.get(`/api/advisor/getunmappedaccount/${unmappedAccountId}`);
        };
        getMapUnmappedAccount(unmappedAccountId: number): ng.IHttpPromise<domains.IAccount> {
            return this.$http.get(`/api/advisor/getmapunmappedaccount/${unmappedAccountId}`);
        };
        getAccountsByInvestor(investorId: number, accountStatus: number, showClosedAccounts: boolean, withAUM: boolean, includeChildAccounts: boolean, accountsFilter?: domains.IAccountFilter): ng.IHttpPromise<Array<domains.IAccount>> {
            var filter: string = null;
            if (accountsFilter != null)
                filter = JSON.stringify(accountsFilter);
            return this.$http.get(`/api/advisor/getaccountsbyinvestor/` + investorId + `/` + accountStatus + `/` + showClosedAccounts + `/` + withAUM + '/' + includeChildAccounts + '/' + filter);
        };
        getAccountsByHousehold(householdId: number, accountStatus: number, showClosedAccounts: boolean, withAUM: boolean, includeChildAccounts: boolean, accountsFilter?: domains.IAccountFilter): ng.IHttpPromise<Array<domains.IAccount>> {
            var filter: string = null;
            if (accountsFilter != null)
                filter = JSON.stringify(accountsFilter);
            return this.$http.get(`/api/advisor/getaccountsbyhousehold/` + householdId + `/` + accountStatus + `/` + showClosedAccounts + `/` + withAUM + '/' + includeChildAccounts + '/' + filter);
        };
        checkIsProductInactive(accountId: number): ng.IHttpPromise<boolean> {
            return this.$http.get("/api/advisor/checkproduct/" + accountId);
        };
        checkIsProductInactiveForProposalInvestments(accountId: number): ng.IHttpPromise<Array<domains.IProposalInvestmentModel>> {
            return this.$http.get("/api/advisor/checkproductproposalinvestments/" + accountId);
        };

        // moved to AccountApi service
        //getAccount(accountId: number): ng.IHttpPromise<domains.IAccount> {
        //    return this.$http.get(`/api/advisor/getaccount/` + accountId);
        //};

        //getPPAccount(ppAccountId: number): ng.IHttpPromise<domains.IPPAccountProfile> {
        //    return this.$http.get(`/api/advisor/getppaccount/` + ppAccountId);
        //};
        getBOAccount(ppAccountId: number): ng.IHttpPromise<domains.IBOAccount> {
            return this.$http.get(`/api/advisor/getboaccount/` + ppAccountId);
        };
        unlockAccountNumber(accountId: number): ng.IHttpPromise<string> {
            return this.$http.get(`/api/advisor/unlockaccountnum/${accountId}`);
        };
        cancelAccount(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/cancelaccount`, this.getAccountForPost(account));
        };
        closeAccount(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/closeaccount`, this.getAccountForPost(account));
        };
        activateAccount(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/activateaccount`, this.getAccountForPost(account));
        };
        openAccount(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/openaccount`, this.getAccountForPost(account));
        };
        renameAccount(accountId: number, accountName: string): ng.IHttpPromise<domains.IAccount> {
            var aname = encodeURIComponent(encodeURIComponent(accountName));
            return this.$http.put(`api/advisor/renameaccount/${accountId}/${aname}`, { accountId: accountId, accountName: aname });
        };
        modifyProductDescription(accountId: number, productDescription: string): ng.IHttpPromise<domains.IAccount> {
            var pdesc = encodeURIComponent(encodeURIComponent(productDescription));
            return this.$http.put(`api/advisor/updateproductdescription/${accountId}/${pdesc}`, { accountId: accountId, productDescription: pdesc });
        };
        updateAccount(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/updateaccount`, this.getAccountForPost(account));
        };
        cancelManualAccount(accountId: number): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/cancelManualAccount/${accountId}`, { accountId: accountId });
        };
        closeManualAccount(accountId: number, utcCloseDate: Date): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/closeManualAccount/${accountId}`, { accountId: accountId, closeDate: utcCloseDate });
        };
        reopenManualAccount(accountId: number): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/reopenManualAccount/${accountId}`, { accountId: accountId });
        };
        updateAccountsRepFeeGroup(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/updateaccountrepfeegroup`, this.getAccountForPost(account));
        };
        //syncAccountGroupWithPp(accountGroupId: number): ng.IHttpPromise<any> {
        //    return this.$http.post(`/api/advisor/syncaccountgroupwithpp/${accountGroupId}`, null);
        //};
        //syncHouseholdWithPp(accountGroupId: number): ng.IHttpPromise<any> {
        //    return this.$http.post(`/api/advisor/synchouseholdwithpp/${accountGroupId}`, null);
        //};
        assignAccountToRTG(link: domains.IAccountGroupAccount): ng.IHttpPromise<domains.IAccountGroupAccount[]> {
            return this.$http.post(`/api/advisor/assignaccounttortg`, link);
        };
        addAccountToHousehold(link: domains.IAccountGroupAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/addaccounttohousehold`, link);
        };
        getAccountDocumentation(accountId: number, includeHistory: boolean = false, showDeletedFiles: boolean = false, custodianAccountId: number = 0, includeEsignatureInfo: boolean = false, includeAllInvestorDocs: boolean = false): ng.IHttpPromise<any[]> {
            return this.$http.get(`api/advisor/getaccountdocumentation/${accountId}/${includeHistory}/${showDeletedFiles}/${custodianAccountId}/${includeEsignatureInfo}/${includeAllInvestorDocs}`);
        };
        getInvestorDocumentation(investorId: number, includeHistory: boolean = false, showDeletedFiles: boolean = false): ng.IHttpPromise<any[]> {
            return this.$http.get(`api/advisor/getinvestordocumentation/${investorId}/${includeHistory}/${showDeletedFiles}`);
        };
        disableDocument(documentId: number, documentVersion: number): ng.IHttpPromise<any> {
            return this.$http.delete(`api/advisor/disabledocument/${documentId}/${documentVersion}`);
        };
        enableDocument(documentId: number, documentVersion: number): ng.IHttpPromise<any> {
            return this.$http.delete(`api/advisor/enabledocument/${documentId}/${documentVersion}`);
        };
        uploadDocumentToCustodian(accountId: number, documentId: number, documentVersion: number): ng.IHttpPromise<any> {
            return this.$http.get(`api/advisor/uploaddoc2custodian/${accountId}/${documentId}/${documentVersion}`);
        };
        resetDocusignEnvelopeStatus(accountId: number, docusignEnvelopeId: string): ng.IHttpPromise<any> {
            return this.$http.delete(`api/advisor/resetdocusignenvelopestatus/${accountId}/${docusignEnvelopeId}`);
        };
        //sendDocumentForSignature(accountId: number, documentId: number, documentVersion: number): ng.IHttpPromise<any> {
        //    return this.$http.get(`api/advisor/senddocforsignature/${accountId}/${documentId}/${documentVersion}`);
        //};
        getESigExtInterfacesForAccount(accountId: number): ng.IHttpPromise<any[]> {
            return this.$http.get(`api/advisor/getesiginterfacesforaccount/${accountId}`);
        };
        getESigExtInterfacesForAdvisor(): ng.IHttpPromise<any[]> {
            return this.$http.get(`api/advisor/getesiginterfacesforadvisor`);
        };
        addToESignature(bulkEnvSetup: domains.IESignatureBulkSetupModel): ng.IHttpPromise<string> {
            return this.$http.post(`/api/advisor/sendtoesignature`, bulkEnvSetup);
        };
        crtUpdCustodianAcctFromAcct(custodianAccount: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/crtupdcustodianacctfromacct`, this.getAccountForPost(custodianAccount));
        };
        crtUpdCustodianAcctFromAcctWithReserve(custodianAccount: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/crtupdcustodianacctfromacct_r`, this.getAccountForPost(custodianAccount));
        };
        uploadDataToCustodian(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/uploaddata2custodian`, this.getAccountForPost(account));
        };
        setExternalHoldingsUpdate(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/setexternalholdings`, this.getAccountForPost(account));
        };
        deleteHoldingsAccount(account: domains.IAccount): ng.IHttpPromise<domains.IAccount> {
            return this.$http.post(`/api/advisor/deleteholdingsforaccount`, this.getAccountForPost(account));
        }
        getAccountType(accountId: number): ng.IHttpPromise<domains.InvestmentType> {
            return this.$http.get(`api/advisor/GetAccountType/${accountId}`);
        };
        copyAccount(accountId: number): ng.IHttpPromise<domains.IAccount> {
            return this.$http.get(`/api/advisor/copyaccount/` + accountId);
        };
        getAdvisorFee(accountId: number): ng.IHttpPromise<number> {
            return this.$http.get(`/api/advisor/getadvisorfee/` + accountId);
        };

        /**
        * List of Bo account activities by Advisor
        * */
        getBoAccountActivities(): ng.IHttpPromise<any[]> {
            return this.$http.get(`/api/advisor/getboaccountactivities`);
        };
        // #endregion Accounts

        // #region Account Beneficiaries

        getAccountBeneficiariesByAccountId(accountId): ng.IHttpPromise<domains.IAccountBeneficiary[]> {
            return this.$http.get(`api/advisor/getaccountbeneficiariesforaccountid/` + accountId);
        };

        deleteAccountBeneficiary(id: number): ng.IHttpPromise<any[]> {
            return this.$http.delete(`/api/advisor/deleteAccountBeneficiary/${id}`);
        }

        saveAccountBeneficiaries(model: domains.IAccountBeneficiary[]): ng.IHttpPromise<{}> {
            return this.$http.post(`api/advisor/saveAccountBeneficiaries`, model);
        };
        // #endregion Account Beneficiaries

        generateProposalReport(accountId: number, preview: boolean, proposalId: number): ng.IHttpPromise<any> {
            return this.$http.get(`api/advisor/getproposalsimplereport/${accountId}/${preview}/${proposalId}`, { responseType: 'arraybuffer' });
        };

        // #region Account groups
        getAccountGroup(groupId): ng.IHttpPromise<domains.IAccountGroup> {
            return this.$http.get(`api/advisor/getaccountgroup/` + groupId);
        };
        createAccountGroup(accountGroup: domains.IAccountGroup): ng.IHttpPromise<domains.IAccountGroup> {
            return this.$http.post(`api/advisor/createaccountgroup`, accountGroup);
        };
        renameAccountGroup(accountGroupId: number, accountGroupName: string): ng.IHttpPromise<domains.IAccountGroup> {
            var agname = encodeURIComponent(encodeURIComponent(accountGroupName));
            return this.$http.put(`api/advisor/renameaccountgroup/${accountGroupId}/${agname}`, { accountGroupId: accountGroupId, accountGroupName: accountGroupName });
        };
        addAccountToAccountGroup(link: domains.IAccountGroupAccount): ng.IHttpPromise<domains.IAccountGroupAccount> {
            return this.$http.post(`api/advisor/addaccounttoaccountgroup`, link);
        };
        removeAccountToAccountGroup(link: domains.IAccountGroupAccount): ng.IHttpPromise<{}> {
            return this.$http.post(`api/advisor/removeaccounttoaccountgroup`, link);
        };
        removeAdvisorDefinedGroup(accountGroupId: number): ng.IHttpPromise<{}> {
            return this.$http.post(`api/advisor/removeadvisordefinedgroup/${accountGroupId}`, { accountGroupId: accountGroupId });
        };
        removeHousehold(householdId: number): ng.IHttpPromise<domains.IHousehold> {
            return this.$http.post(`api/advisor/removeHousehold/${householdId}`, { householdId: householdId });
        };
        expireHousehold(householdId: number): ng.IHttpPromise<domains.IHousehold> {
            return this.$http.post(`api/advisor/expireHousehold/${householdId}`, { householdId: householdId });
        };
        getAccountGroupsByGroupType(groupType: number, advisoryFirmId: number): ng.IHttpPromise<domains.IAccountGroup[]> {
            return this.$http.get(`api/advisor/getaccountgroups/` + groupType + "/" + advisoryFirmId);
        };
        getAccountGroupsByAccountId(accountId: number): ng.IHttpPromise<domains.IAccountGroup[]> {
            return this.$http.get(`api/advisor/getaccountgroupsbyaccountid/` + accountId);
        };
        getAdvisoryDefinedGroupsByAccountId(accountId: number): ng.IHttpPromise<domains.IAccountGroup[]> {
            return this.$http.get(`api/advisor/getadvisorydefinedgroups/` + accountId);
        }
        getAvailableAccountsForGroupping(householdId: number, showClosedAccounts: boolean, accountGroupId?: number): ng.IHttpPromise<domains.IAccount[]> {
            return this.$http.get(`api/advisor/getavailableaccountsforgroupping/${householdId}/${showClosedAccounts}/${accountGroupId}`);
        }


        // #endregion Account groups

        // #region Investors
        getAdvisorsForInvestor(investorId: number): ng.IHttpPromise<Array<{}>> {
            return this.$http.get("api/advisor/getadvisorsforinvestor/" + investorId);
        }

        searchInvestorsHouseholds(searchTerm: string): ng.IHttpPromise<Array<{}>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            return this.$http.get(`/api/advisor/searchhouseholdsinvestors/` + sterm);
        }

        searchAccounts(searchTerm: string, accountType?: number): ng.IHttpPromise<Array<{}>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            if (accountType == null) {
                return this.$http.get(`/api/advisor/searchaccounts/` + sterm);
            } else {
                return this.$http.get(`/api/advisor/searchaccounts/` + sterm + "/" + accountType);
            }
        }

        searchOpenAccounts(searchTerm: string, accountType?: number): ng.IHttpPromise<Array<{}>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            if (accountType == null) {
                return this.$http.get(`/api/advisor/searchopenaccounts/` + sterm);
            } else {
                return this.$http.get(`/api/advisor/searchopenaccounts/` + sterm + "/" + accountType);
            }
        }

        searchHouseholds(searchTerm: string): ng.IHttpPromise<Array<{}>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            return this.$http.get(`/api/advisor/searchhousehold/` + sterm);
        }

        getInvestors(): ng.IHttpPromise<domains.IInvestor[]> {
            return this.$http.get(`/api/advisor/getinvestors`);
        }

        getInvestorsLight(): ng.IHttpPromise<domains.IInvestor[]> {
            return this.$http.get(`/api/advisor/getinvestorslight`);
        }

        getInvestorLogins(from: Date, to: Date): ng.IHttpPromise<domains.IInvestor[]> {
            var dates = { from: from, to: to };
            return this.$http.post(`/api/advisor/getinvestorlogins`, dates);
        }

        searchInvestors(searchTerm: string, investorType: number = null, entityType: number = null): ng.IHttpPromise<Array<domains.IInvestor>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            return this.$http.get(`/api/advisor/searchInvestors/${sterm}/${investorType}/${entityType}`);
        }

        getInvestor(id: number, m?: boolean): ng.IHttpPromise<domains.IInvestor> {
            if (m == false)
                return this.$http.get(`/api/advisor/getinvestorm/` + id);
            else
                return this.$http.get(`/api/advisor/getinvestor/` + id);
        }

        getInvestorAnalyst(investorId: number): ng.IHttpPromise<domains.ISalesforceAnalystData> {
            return this.$http.get(`/api/advisor/getinvestoranalyst/${investorId}`);
        }

        getHouseholdAnalysts(householdId: number): ng.IHttpPromise<Array<domains.ISalesforceAnalystData>> {
            return this.$http.get(`/api/advisor/gethouseholdanalysts/${householdId}`);
        }

        createInvestor(model: domains.IInvestor): ng.IHttpPromise<domains.IInvestor> {
            return this.$http.post(`/api/advisor/createinvestor`, model);
        }

        updateInvestor(model: domains.IInvestor): ng.IHttpPromise<domains.IInvestor> {
            return this.$http.post(`/api/advisor/updateinvestor`, model);
        }

        updateAdvisorInvestor(model: domains.IInvestor): ng.IHttpPromise<domains.IInvestor> {
            return this.$http.post(`/api/advisor/updateadvisorinvestor`, model);
        }
        // #endregion Ivnestors

        // #region Managers
        getManagers(advisoryFirmId: number, productTypeId: number): ng.IHttpPromise<domains.IManager[]> {
            return this.$http.get(`/api/advisor/getmanagers/${advisoryFirmId}/${productTypeId}`);
        }
        getAllManagers(productTypeId: number): ng.IHttpPromise<domains.IManager[]> {
            return this.$http.get(`/api/advisor/getallmanagers/${productTypeId}`);
        }
        // #endregion Managers

        // #region Products 
        getProductsByFirm(advisoryFirmId: number, productTypeId: number, managerId: number, investmentType: number = null): ng.IHttpPromise<domains.IManagerProduct[]> {
            return this.$http.get(`/api/advisor/getproducts/${advisoryFirmId}/${productTypeId}/${managerId}/${investmentType}`);
        }
        getProductsByManager(productTypeId: number, managerId: number): ng.IHttpPromise<domains.IManagerProduct[]> {
            return this.$http.get(`/api/advisor/getproducts/${productTypeId}/${managerId}`);
        }
        // #endregion Products

        // /////////////////////////////////////////////
        // advisor methods
        getAdvisorsForCurrentAdvisor(): ng.IHttpPromise<Array<domains.IAdvisor>> {
            return this.$http.get(`/api/advisor/getadvisors`);
        }

        getAdvisor(): ng.IHttpPromise<domains.IAdvisor> {       //it seems to me this service is not in use?
            return this.$http.get(`/api/advisor/getadvisor`);
        }

        getAdvisorById(advisorId: number): ng.IHttpPromise<domains.IAdvisor> {
            return this.$http.get(`/api/advisor/getadvisor/${advisorId}`);
        }

        getCustodiansForAdvisoryFirm(advisoryFirmId: number): ng.IHttpPromise<domains.ICustodianAdvisoryFirm[]> {
            return this.$http.get(`/api/advisor/getcustodiansforadvisoryfirm/${advisoryFirmId}`);
        }

        //fetch all custodians..
        getCustodians(): ng.IHttpPromise<Array<domains.ICustodian>> {
            return this.$http.get("/api/advisor/getcustodians");
        }

        getCustodiansForRepGroup(repGroupId: number): ng.IHttpPromise<Array<domains.IRepFeeGroupCustodian>> {
            return this.$http.get("/api/advisor/getcustodiansforrepgroup/" + repGroupId);
        }

        mapCustodianRepCodeWithRepGroup(model: domains.IRepFeeGroupCustodian): ng.IHttpPromise<domains.IRepFeeGroupCustodian> {
            return this.$http.post("/api/advisor/mapcustodiancodewithrepgroup", model);
        }

        removeCustodianMappedForRepGroup(model: domains.IRepFeeGroupCustodian): ng.IHttpPromise<domains.IRepFeeGroupCustodian> {
            return this.$http.post("/api/advisor/removecustodianfrommappedlist", model);
        }

        getCustodianDocuments(custodianId: number): ng.IHttpPromise<Array<domains.ICustodianDocument>> {
            return this.$http.get("/api/advisor/getcustodiandocuments/" + custodianId);
        }

        searchAdvisors(searchTerm: string): ng.IHttpPromise<Array<domains.IAdvisor>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            return this.$http.get(`/api/advisor/searchAdvisors/${sterm}`);
        }

        searchBOSecurities(searchTerm: string): ng.IHttpPromise<domains.IPPSecurityDetail[]> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            return this.$http.get(`/api/advisor/searchbosecurities/${sterm}`);
        }

        createAdvisor(model: domains.IAdvisor): ng.IHttpPromise<{ data, warnings: any[] }> {
            return this.$http.post(`/api/advisor/createadvisor`, model);
        }

        updateAdvisor(model: domains.IAdvisor): ng.IHttpPromise<number> {
            return this.$http.post(`/api/advisor/updateadvisor`, model);
        }
        setAdvisorRepId(model: domains.IAdvisorCustodian): ng.IHttpPromise<domains.IAdvisorCustodian> {
            //we will clean model first 
            const m: domains.IAdvisorCustodian = {};
            angular.copy(model, m);
            m.custodian = null;
            m.advisoryFirm = null;
            //console.log(`New object: `, m);
            return this.$http.post(`/api/advisor/setadvisorrepid`, m);
        }
        removeAdvisorRepId(advisorCustodianId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/advisor/removeadvisorrepid/${advisorCustodianId}`);
        }

        getAdvisoryLeadsForCompanyGroup(): ng.IHttpPromise<Array<domains.IAdvisor>> {
            return this.$http.get("/api/advisor/getadvisoryleadsforcompanygroup");
        }

        //getAccountPPAccountData(usCode: string, advisoryFirmId?: number): ng.IHttpPromise<Array<domains.IAccountPPAccountData>> {
        //    if (advisoryFirmId) {
        //        return this.$http.get(`/api/advisor/getaccountppaccountdata/${usCode}/${advisoryFirmId}`);
        //    } else {
        //        return this.$http.get(`/api/advisor/getaccountppaccountdata/${usCode}`);
        //    }
        //}

        getAcctValueMonitorData(adminMode: boolean, manualsOnly: boolean, advisoryFirmId?: number): ng.IHttpPromise<any[]> {
            if (advisoryFirmId) {
                return this.$http.get(`/api/advisor/acctvaluemonitor/${adminMode}/${manualsOnly}/${advisoryFirmId}`);
            } else {
                return this.$http.get(`/api/advisor/acctvaluemonitor/${adminMode}/${manualsOnly}`);
            }
        };

        getCashMonitorData(adminMode: boolean, advisoryFirmId?: number): ng.IHttpPromise<any[]> {
            if (advisoryFirmId) {
                return this.$http.get(`/api/advisor/cashmonitor/${adminMode}/${advisoryFirmId}`);
            } else {
                return this.$http.get(`/api/advisor/cashmonitor/${adminMode}`);
            }
        };

        // #region Identity
        enableAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/enableadvisorsl`, model);
        };

        setTwoFactorAdvisorSL(model: domains.IAdvisor, enabled: boolean, days?: number): ng.IHttpPromise<{}> {
            const period = days ? `?days=${days}` : "";
            return this.$http.post(`/api/advisor/settwofactoradvisorsl/${enabled}${period}`, model);
        };

        setSsoModeAdvisorSL(model: domains.IAdvisor, mode: number): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/setssomodeadvisorsl/${mode}`, model);
        };

        reactivateAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/reactivateadvisorsl`, model);
        };

        disableAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/disableadvisorsl`, model);
        };

        lockAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/lockadvisorsl`, model);
        };

        unlockAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/unlockadvisorsl`, model);
        };

        // #endregion Identity


        ////////////////////////////////////////////////////
        ///////////////////////ADVISOR NOTES///////////////
        ///////////////////////////////////////////////////

        createNote(note: domains.INote, type: domains.NotesType): ng.IHttpPromise<domains.INote> {
            if (type == domains.NotesType.INVESTOR)
                return this.$http.post(`/api/advisor/addnoteforinvestor`, note);
            else if (type == domains.NotesType.HOUSEHOLD)
                return this.$http.post(`/api/advisor/addnoteforhousehold`, note);
            else {
                note.notesType = type;
                return this.$http.post(`/api/advisor/addnote`, note);
            }
        };

        updateNote(note: domains.INote, type: domains.NotesType): ng.IHttpPromise<domains.INote> {
            if (type == domains.NotesType.INVESTOR)
                return this.$http.post(`/api/advisor/updatenoteforinvestor/`, note);
            else if (type == domains.NotesType.HOUSEHOLD)
                return this.$http.post(`/api/advisor/updatenoteforhousehold/`, note);
            else {
                note.notesType = type;
                return this.$http.post(`/api/advisor/updatenote`, note);
            }
        };

        deleteNote(model: domains.INote): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/deletenote`, model);
        };

        getNotes(objectId: number, showDeleted: boolean, type: domains.NotesType): ng.IHttpPromise<Array<domains.INote>> {
            if (type == domains.NotesType.INVESTOR)
                return this.$http.get(`/api/advisor/getnotesforinvestor/` + objectId + "/" + showDeleted);
            else if (type == domains.NotesType.HOUSEHOLD)
                return this.$http.get(`/api/advisor/getnotesforhousehold/` + objectId + "/" + showDeleted);
            else
                return this.$http.get(`/api/advisor/getnotes/${objectId}/${showDeleted}/${type}`);
        };

        getNoteById(noteId: number): ng.IHttpPromise<domains.INote> {
            return this.$http.get(`/api/advisor/getnotebyid/` + noteId);
        };


        // //////////////////////////////////////////
        // title methods
        searchTitles(searchTerm: string, titleType: number): ng.IHttpPromise<Array<domains.ITitle>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            return this.$http.get(`/api/advisor/searchtitles/${sterm}/${titleType}`);
        };
        searchTitlesByInvestors(investors: Array<domains.IInvestor>): ng.IHttpPromise<Array<domains.ITitle>> {
            return this.$http.post(`/api/advisor/searchtitles`, investors);
        };
        getTitle(titleId: number): ng.IHttpPromise<domains.ITitle> {
            return this.$http.get(`/api/advisor/gettitle/` + titleId);
        };
        createTitle(model: domains.ITitle): ng.IHttpPromise<domains.ITitle> {
            return this.$http.post(`/api/advisor/createtitle`, model);
        };
        saveTitle(model: domains.ITitle): ng.IHttpPromise<domains.ITitle> {
            return this.$http.post(`/api/advisor/savetitle`, model);
        };
        addInvestorToTitle(model: domains.ITitleInvestor): ng.IHttpPromise<domains.ITitleInvestor> {
            return this.$http.post(`/api/advisor/addinvestortotitle`, model);
        };
        removeInvestorFromTitle(model: domains.ITitleInvestor): ng.IHttpPromise<domains.ITitleInvestor> {
            return this.$http.post(`/api/advisor/removeinvestorfromtitle`, model);
        };



        // ////////////////////////////////////////////////////////

        // RTQ / RTG
        getNewRTQ(rtqType: number): ng.IHttpPromise<domains.IRTQ> {
            return this.$http.get(`/api/advisor/getnewrtq/` + rtqType);
        };
        getRTQ(id: number): ng.IHttpPromise<domains.IRTQ> {
            return this.$http.get(`/api/advisor/getrtq/` + id);
        };
        getRTQs(titleId: number): ng.IHttpPromise<Array<domains.IRTQ>> {
            return this.$http.get(`/api/advisor/getrtqs/` + titleId);
        }
        saveRTQ(model: domains.IRTQ): ng.IHttpPromise<domains.IRTQ> {
            return this.$http.post(`/api/advisor/savertq`, model);
        };
        finishRTQ(model: domains.IRTQ): ng.IHttpPromise<domains.IRTQ> {
            return this.$http.post(`/api/advisor/finishrtq`, model);
        };
        renewRTQ(model: domains.IRTQ): ng.IHttpPromise<domains.IRTQ> {
            return this.$http.post(`/api/advisor/renewrtq`, model);
        };
        getRtg(rtgId: number): ng.IHttpPromise<domains.IAccountGroup> {
            return this.$http.get(`/api/advisor/getrtg/` + rtgId);
        };
        getRTGByInvestor(investorId: number): ng.IHttpPromise<domains.IAccountGroup[]> {
            return this.$http.get(`/api/advisor/getrtgsbyinvestor/` + investorId);
        };
        getRTGByHousehold(householdId: number): ng.IHttpPromise<Array<domains.IAccountGroup>> {
            return this.$http.get(`/api/advisor/getrtgsbyhousehold/` + householdId);
        };

        // //////////////////////////////////////////////////
        // MEMO Account

        getMemoAccounts(): ng.IHttpPromise<Array<domains.IMemoAccount>> {
            return this.$http.get(`/api/advisor/getmemoaccounts`);
        };


        // #region Proposals 
        createOrUpdateProposal(model: domains.IProposal): ng.IHttpPromise<domains.IProposal> {
            model.account = null;
            model.title = null;
            return this.$http.post(`/api/advisor/createproposal`, model);
        };

        newCreateOrUpdateProposal(model: domains.IProposal): ng.IHttpPromise<domains.IProposal> {
            model.account = null;
            model.title = null;
            //var mod: domains.IProposal = {};
            //angular.copy(model, mod);
            //console.log("PROPOSAL MODEL TO UPDATE:", mod);
            return this.$http.post(`/api/advisor/newcreateproposal`, model);
        };

        getProposalsByTitle(titleId: number): ng.IHttpPromise<Array<domains.IProposal>> {
            return this.$http.get(`/api/advisor/getproposalsbytitle/` + titleId);
        };

        getProposals(): ng.IHttpPromise<Array<domains.IProposal>> {
            return this.$http.get(`/api/advisor/getproposals`);
        };

        getProposal(id: number): ng.IHttpPromise<domains.IProposal> {
            return this.$http.get(`/api/advisor/getproposal/` + id);
        };

        getWorkingProposal(accountId: number): ng.IHttpPromise<domains.IProposal> {
            return this.$http.get(`/api/advisor/getworkingproposal/` + accountId);
        };

        getInvestmentModels(advisoryFirmId: number): ng.IHttpPromise<Array<domains.IInvestmentModel>> {
            return this.$http.get(`/api/advisor/getinvestmentmodels/` + advisoryFirmId);
        };

        getOtherProposalFees(advisoryFirmId: number): ng.IHttpPromise<domains.IOtherProposalFee> {
            return this.$http.get(`/api/advisor/getotherproposalfees/` + advisoryFirmId);
        };

        getOtherAccountProposalFees(accountId: number): ng.IHttpPromise<domains.IAccountProposalFees[]> {
            return this.$http.get(`/api/advisor/getotheraccountproposalfees/` + accountId);
        };

        rollbackProposal(currentProposalId: number, previousActiveProposal: number): ng.IHttpPromise<domains.IProposal> {
            return this.$http.get('api/advisor/rollbackproposal/' + currentProposalId + '/' + previousActiveProposal);
        }

        signProposal(proposal: domains.IProposal): ng.IHttpPromise<domains.IProposal> {

            //cleaning investment model object we don't need to send this data to the server
            var prop: domains.IProposal = {};
            angular.copy(proposal, prop);

            //for (var i = 0; i < prop.investmentModels.length; i++)
            //    prop.investmentModels[0].investmentModel = null;
            return this.$http.post(`/api/advisor/signproposal`, prop);
        };

        //activateProposal(proposal: domains.IProposal): ng.IHttpPromise<domains.IProposal> {
        //    return this.$http.post(`/api/advisor/activateproposal/${proposal.id}/${proposal.accountId}`, null);
        //};

        cancelProposal(proposal: domains.IProposal): ng.IHttpPromise<domains.IProposal> {
            return this.$http.post(`/api/advisor/cancelproposal/${proposal.id}/${proposal.accountId}`, null);
        };

        // #endregion Proposals 


        // #region Risk Monitor & Securities
        startRiskMonitor(advisoryFirmId: number, securityAllocationPlanId: number): ng.IHttpPromise<{}> {
            return this.$http.get(`/api/advisor/startriskmonitor/${advisoryFirmId}/${securityAllocationPlanId}`);
        };
        startRiskMonitorForAllFirms(): ng.IHttpPromise<{}> {
            return this.$http.get(`/api/advisor/startriskmonitor`);
        };
        getSecurityAllocationPlans(advisoryFirmId: number): ng.IHttpPromise<domains.ISecurityAllocationPlan[]> {
            return this.$http.get(`/api/advisor/getsecurityallocationplans/${advisoryFirmId}`);
        };
        getAFSecurityAllocationPlans(advisoryFirmId: number): ng.IHttpPromise<domains.IAFSecurityAllocationPlan[]> {
            return this.$http.get(`/api/advisor/getafsecurityallocationplans/${advisoryFirmId}`);
        };
        getSecurityAllocationPlan(allocationPlanId: number): ng.IHttpPromise<domains.ISecurityAllocationPlan> {
            return this.$http.get(`/api/advisor/getsecurityallocationplan/${allocationPlanId}`);
        };
        //getAFSecurityAllocationPlan(allocationPlanId: number): ng.IHttpPromise<domains.IAFSecurityAllocationPlan> {
        //    return this.$http.get(`/api/advisor/getafsecurityallocationplan/${allocationPlanId}`);
        //};
        //cloneSecurityAllocationPlan(advisoryFirmId: number, newAllocationPlanName: string, originalPlan: domains.ISecurityAllocationPlan): ng.IHttpPromise<domains.ISecurityAllocationPlan> {
        //    var newname = encodeURIComponent(this.replaceSlashes(newAllocationPlanName));
        //    return this.$http.post(`/api/advisor/clonesecurityallocationplan/${advisoryFirmId}/${newname}`, originalPlan);
        //};
        //updateSecurityAssetClassAllocation(allocation: domains.ISecurityAssetClass): ng.IHttpPromise<domains.ISecurityAllocationPlan> {
        //    return this.$http.post(`/api/advisor/updatesecurityassetclassallocation`, allocation);
        //};
        getProtectiveSecurityDetails(uniqueSecId: string): ng.IHttpPromise<domains.ISecurityNote> {
            return this.$http.get(`/api/advisor/getprotectivesecuritydetails/${uniqueSecId}`);
        };
        // #endregion Risk Monitor & Securities


        // #region Household
        getHouseholds(withAum: boolean, withAdvisors: boolean, includeClosed?: boolean): ng.IHttpPromise<Array<domains.IHousehold>> {
            const url = `/api/advisor/gethouseholds/${withAum}/${withAdvisors}/${includeClosed ?? false}`;
            return this.$http.get(url);
        };

        getHouseholdsForAccount(accountId: number): ng.IHttpPromise<Array<domains.IHousehold>> {
            return this.$http.get(`/api/advisor/gethouseholdsforaccount/` + accountId);
        };
        getHouseholdsByInvestor(investorId: number): ng.IHttpPromise<Array<domains.IHousehold>> {
            return this.$http.get(`/api/advisor/gethouseholdsbyinvestor/` + investorId);
        };
        getHouseholdGroupsByInvestors(investors: number[]): ng.IHttpPromise<Array<domains.IAccountGroup>> {
            return this.$http.post(`/api/advisor/gethouseholdgroupsbyinvestors`, investors);
        };

        getAllHouseholdsByInvestor(investorId: number): ng.IHttpPromise<Array<domains.IHousehold>> {
            return this.$http.get(`/api/advisor/getallhouseholdsbyinvestor/` + investorId);
        };
        getHousehold(householdId: number): ng.IHttpPromise<domains.IHousehold> {
            return this.$http.get(`/api/advisor/gethousehold/` + householdId);
        };
        createUpdateHousehold(household: domains.IHousehold): ng.IHttpPromise<domains.IHousehold> {
            return this.$http.post(`/api/advisor/createupdatehousehold`, household);
        };
        // #endregion Households

        // ///////////////////////////////////////////
        // household dashboard

        // moved to HouseholdApi
        //getHDAccounts(groupType: number, householdId: number, showClosedInactive?: boolean): ng.IHttpPromise<any> {
        //    //if (householdId)
        //    return this.$http.get(`api/advisor/gethdaccounts/${groupType}/${householdId}/${showClosedInactive}`);
        //    //else
        //    //return this.$http.get(`api/advisor/gethdaccounts/${groupType}/${showClosedInactive}`);
        //};

        // moved to HouseholdApi
        //getHDCharts(householdId: number, groupType: number, chartGroup: string, groupId: number, accountId: number, sleeveId: number, showClosedInactive?: boolean): ng.IHttpPromise<domains.IChartDataSource[]> {
        //    return this.$http.get(`api/advisor/gethouseholddashboardcharts/${householdId}/${groupType}/${chartGroup}/${groupId}/${accountId}/${sleeveId}/${showClosedInactive}`);
        //};

        // ///////////////////////////////////////////
        // rtg dashboard

        // moved to AccountGroupApi.ts service
        //getAccountGroupAccounts(groupId?: number): ng.IHttpPromise<any> {
        //    return this.$http.get(`api/advisor/getaccountgroupaccounts/` + groupId);
        //};

        // moved to AccountGroupApi.ts service
        //getRtgPerformanceDetails(rtgId: number): ng.IHttpPromise<any> {
        //    return this.$http.get(`api/advisor/getaccountgroupperformancedetails/` + rtgId);
        //};

        // moved to AccountGroupApi.ts service
        //getRtgPerformanceDetails(rtgId: number): ng.IHttpPromise<any> {
        //    return this.$http.get(`api/advisor/getaccountgroupperformancedetails/` + rtgId);
        //};

        getRtgPerformanceDetailsP2P(rtgId: number, fromDate: Date, toDate: Date, showClosedInact: boolean): ng.IHttpPromise<any> {
            const req: domains.IPerformanceDetailsP2PRequest = {
                fromDate: fromDate,
                toDate: toDate,
                groupId: rtgId,
                showClosedInactive: showClosedInact
            };
            return this.$http.post(`api/advisor/getaccountgroupperformancedetailsP2P`, req);
        };

        // //////////////////////////////////////////////////
        // individual dashboard
        getIDCharts(investorId: number): ng.IHttpPromise<domains.IChartDataSource[]> {
            return this.$http.get(`api/advisor/getinvestordashboardcharts/` + investorId);
        };

        // ///////////////////////////////////////////
        // charts AUM
        getMarketValueByInvestor(investorId: number): ng.IHttpPromise<domains.IChartDataSource> {
            return this.$http.get(`/api/advisor/getmarketvaluebyinvestor/` + investorId);
        };
        getMarketValueByHousehold(householdId: number): ng.IHttpPromise<domains.IChartDataSource> {
            return this.$http.get(`/api/advisor/getmarketvaluebyhousehold/` + householdId);
        };
        getMarketValueByPrimaryAdvisor(adminMode: boolean, advisoryFirmId?: number): ng.IHttpPromise<domains.IChartDataSource> {
            if (advisoryFirmId) {
                return this.$http.get(`/api/advisor/getmarketvaluebyprimaryadvisor/${adminMode}/${advisoryFirmId}`);
            } else {
                return this.$http.get(`/api/advisor/getmarketvaluebyprimaryadvisor/${adminMode}`);
            }
        };
        // charts holdings
        getTopNHoldingsByInvestor(investorId: number): ng.IHttpPromise<domains.IChartDataSource> {
            return this.$http.get(`/api/advisor/gettopnholdingsbyinvestor/` + investorId);
        };
        getTopNHoldingsByHousehold(householdId: number): ng.IHttpPromise<domains.IChartDataSource> {
            return this.$http.get(`/api/advisor/gettopnholdingsbyhousehold/` + householdId);
        };
        getTopNHoldingsByAdvisor(adminMode: boolean, advisoryFirmId?: number, numOfRec?: number): ng.IHttpPromise<domains.IChartDataSource> {
            if (!numOfRec) {
                numOfRec = 10;
            }

            if (!adminMode) {
                adminMode = false;
            }

            if (advisoryFirmId) {
                return this.$http.get(`/api/advisor/gettopnholdingsbyadvisor/${adminMode}/${advisoryFirmId}?numOfRec=${numOfRec}`);
            } else {
                return this.$http.get(`/api/advisor/gettopnholdingsbyadvisor/${adminMode}?numOfRec=${numOfRec}`);
            }
        };
        getTopNModelsByAdvisor(adminMode: boolean, advisoryFirmId?: number, numOfRec?: number): ng.IHttpPromise<domains.IChartDataSource> {
            if (!numOfRec) {
                numOfRec = 10;
            }

            if (!adminMode) {
                adminMode = false;
            }

            if (advisoryFirmId) {
                return this.$http.get(`/api/advisor/gettopnmodelsbyadvisor/${adminMode}/${advisoryFirmId}?numOfRec=${numOfRec}`);
            } else {
                return this.$http.get(`/api/advisor/gettopnmodelsbyadvisor/${adminMode}?numOfRec=${numOfRec}`);
            }
        };
        // top N clients  holdings gettopnclients
        getTopNClients(adminMode: boolean, size: number, advisoryFirmId?: number): ng.IHttpPromise<domains.IChartDataSource> {

            if (!adminMode) {
                adminMode = false;
            }

            if (advisoryFirmId)
                return this.$http.get(`/api/advisor/gettopnclients/${adminMode}/${size}/${advisoryFirmId}`);
            else
                return this.$http.get(`/api/advisor/gettopnclients/${adminMode}/${size}`);
        };
        getTopNHouseholds(adminMode: boolean, size: number, advisoryFirmId?: number): ng.IHttpPromise<domains.IChartDataSource> {
            if (advisoryFirmId)
                return this.$http.get(`/api/advisor/gettopnhouseholds/${adminMode}/${size}/${advisoryFirmId}`);
            else
                return this.$http.get(`/api/advisor/gettopnhouseholds/${adminMode}/${size}`);
        };



        // #region Individual system login
        enableInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/enableinvestorsl`, model);
        };

        reactivateInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/reactivateinvestorsl`, model);
        };

        reactivateLinkInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/reactivatelinkinvestorsl`, model);
        };

        passwordLinkInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/pwlinkinvestorsl`, model);
        };

        disableInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/disableinvestorsl`, model);
        };

        lockInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/lockinvestorsl`, model);
        };

        unlockInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/advisor/unlockinvestorsl`, model);
        };

        setTwoFactorInvestorSL(model: domains.IInvestor, enabled: boolean, days?: number): ng.IHttpPromise<{}> {
            const period = days ? `?days=${days}` : "";
            return this.$http.post(`/api/advisor/settwofactorinvestorsl/${enabled}${period}`, model);
        };
        // #endregion Individual system login

        // #region Outside investment holdings
        getOutsideHoldings(accountId: number): ng.IHttpPromise<any> {
            return this.$http.get(`/api/advisor/getoutsideinvestmentholdings/${accountId}`);
        }
        getOutsideHoldingsAndClassns(accountId: number): ng.IHttpPromise<any> {
            return this.$http.get(`/api/advisor/getoutsideinvestmentholdingsandclassns/${accountId}`);
        }
        saveOutsideHoldings(holding: any): ng.IHttpPromise<any[]> {
            return this.$http.post(`/api/advisor/saveoutsideinvestmentholdings`, holding);
        }
        deleteOutsideHoldings(accountId: number): ng.IHttpPromise<any[]> {
            return this.$http.delete(`/api/advisor/deleteoutsideinvestmentholding/${accountId}`);
        }
        // #endregion Outside investment holdings

        // //////////////////////////////////////////
        // test redtail
        //testRedTail(): ng.IHttpPromise<{}> {
        //    return this.$http.get(`/api/advisor/testredtail`);
        //}

        //testLaserApp(formGuid: string): ng.IHttpPromise<string> {
        //    return this.$http.get(`/api/advisor/testlaserapp/${formGuid}`);
        //}

        //testDocusign(uuid: string): ng.IHttpPromise<string> {
        //    return this.$http.get(`/api/signDocument/${uuid}`);
        //}

        //generateLaserAppForm(formGuid: string, accountId: number): ng.IHttpPromise<string> {
        //    return this.$http.get(`/api/advisor/generatelaserappform/${formGuid}/${accountId}`);
        //}

        //generateLaserAppForms(accountId: number, formGuids: string[]): ng.IHttpPromise<string> {
        //    return this.$http.post(`/api/advisor/generatelaserappforms/${accountId}`, formGuids);
        //}

        generateLaserAppForms(accountId: number, laserAppGenRequest: domains.ILaserAppGenRequest[]): ng.IHttpPromise<string> {
            return this.$http.post(`/api/advisor/generatelaserappforms/${accountId}`, laserAppGenRequest);
        }

        //getLaserAppForm(accountId: number, formGuid: string): ng.IHttpPromise<string>
        //{
        //    return this.$http.get(`/api/advisor/la/subscriptionagreement/${accountId}/${formGuid}`);
        //}

        getSubscriptionAgreement(accountId: number, preview: boolean): ng.IHttpPromise<string> {
            return this.$http.get(`/api/advisor/getsubscriptionagreement/${accountId}/${preview}`);
        }

        // /////////////////////////////////////////
        // DocuSign apis
        ds_logininformation(): ng.IHttpPromise<{}> {
            return this.$http.get(`/api/advisor/docusign/logininformation`);
        };

        getExternalSystems(): ng.IHttpPromise<Array<domains.IAdvisorExternalSystem>> {
            return this.$http.get(`/api/advisor/getExternalSystems`);
        };

        getExternalSystem(id: number): ng.IHttpPromise<domains.IAdvisorExternalSystem> {
            return this.$http.get(`/api/advisor/getExternalSystem/${id}`);
        };

        loadSalesforceUsers(): ng.IHttpPromise<any[]> {
            return this.$http.get(`/api/advisor/loadSalesforceUsers`);
        }

        loadOrionRepresentatives(): ng.IHttpPromise<any[]> {
            return this.$http.get(`/api/orion/representatives`);
        }

        createSalesforceUser(user: domains.salesforce.ISalesforceUser): ng.IHttpPromise<any[]> {
            return this.$http.post(`/api/advisor/createsalesforceuser`, user);
        }

        changeSystemConfiguration(config: domains.externalsystem.IExternalSystemConfig): ng.IHttpPromise<domains.externalsystem.IExternalSystemConfig> {
            return this.$http.post(`/api/advisor/changesystemconfiguration`, config);
        }

        createGlobalSalesforceConfiguration(config: domains.externalsystem.IExternalSystemConfig): ng.IHttpPromise<domains.externalsystem.IExternalSystemConfig> {
            return this.$http.post(`/api/advisor/createGlobalSalesforceConfiguration`, config);
        }

        resetSystemConfiguration(config: domains.externalsystem.IExternalSystemConfig): ng.IHttpPromise<domains.externalsystem.IExternalSystemConfig> {
            return this.$http.post(`/api/advisor/resetsystemconfiguration`, config);
        }

        getSystemConfiguration(externalSystemId: number, configurationType: domains.ConfigurationType = domains.ConfigurationType.ALL): ng.IHttpPromise<domains.externalsystem.IExternalSystemConfig> {
            return this.$http.get(`/api/advisor/getsystemconfiguration/${externalSystemId}/${configurationType}`);
        }

        createOrSaveObjectLink(salesforceObjectLink: domains.externalsystem.ISalesforceObjectLink): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/changeSalesforceObjectLink`, salesforceObjectLink);
        }

        getObjectLink(companyGroupId: number, advisorObject: domains.AdvisorObject): ng.IHttpPromise<any> {
            return this.$http.get(`/api/advisor/getSalesforceObjectLink/${companyGroupId}/${advisorObject}`);
        }

        getSalesforceObjectFields(configuration: domains.externalsystem.IExternalSystemConfig, salesforceObject: domains.SalesforceObject): ng.IHttpPromise<Array<domains.externalsystem.IObjectField>> {
            return this.$http.post(`/api/advisor/getSalesforceObjectFields/${salesforceObject}`, configuration);
        }

        getAllSalesforceObjects(configuration: domains.externalsystem.IExternalSystemConfig): ng.IHttpPromise<Array<any>> {
            return this.$http.post(`/api/advisor/getAllSalesforceObjects`, configuration);
        }

        getSalesforceClassMap(configuration: domains.externalsystem.IExternalSystemConfig, salesforceObject: domains.SalesforceObject, advisorObject: domains.AdvisorObject): ng.IHttpPromise<Array<domains.externalsystem.IExternalSystemsClassMapping>> {
            return this.$http.post(`/api/advisor/getSalesforceClassMap/${salesforceObject}/${advisorObject}`, configuration);
        }

        checkApiConnection(config: domains.externalsystem.IExternalSystemConfig): ng.IHttpPromise<any[]> {
            return this.$http.post(`/api/advisor/checkapiconnection`, config);
        };

        getSalesforceUser(config: domains.externalsystem.IExternalSystemConfig): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/getsalesforceUser`, config);
        };

        syncData(id: number): ng.IHttpPromise<domains.externalsystem.ISyncDataMessage> {
            return this.$http.get(`/api/advisor/syncdatawithexternalsystem/${id}`);
        };

        syncHouseholdData(id: number): ng.IHttpPromise<domains.externalsystem.ISyncDataMessage> {
            return this.$http.get(`/api/advisor/synchouseholdswithsalesforcre/${id}`);
        };

        syncInvestorWithCRM(investorId: number): ng.IHttpPromise<any> {
            return this.$http.put(`/api/advisor/syncinvestor/${investorId}`, { investorId: investorId });
        };

        resetSyncData(id: number): ng.IHttpPromise<any> {
            return this.$http.get(`/api/advisor/resetSyncData/${id}`);
        };

        testSalesforceAdminConfig(config: domains.externalsystem.IExternalSystemConfig): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/testSalesforceAdminConfiguration`, config);
        };

        createOrSaveClassMapp(classMapp: Array<domains.externalsystem.IExternalSystemsClassMapping>): ng.IHttpPromise<Array<domains.externalsystem.IExternalSystemsClassMapping>> {
            return this.$http.post(`/api/advisor/changeExternalClassMap`, classMapp);
        };

        testSalesforceImportAllContacts(salesForceConfig: domains.externalsystem.IExternalSystemConfig, sourceData: boolean = false): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/testSalesforceImportAllContacts/${sourceData}`, salesForceConfig);
        };


        testSalesforceImportAllHouseholds(salesForceConfig: domains.externalsystem.IExternalSystemConfig, sourceData: boolean = false): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/testSalesforceImportAllHouseholds/${sourceData}`, salesForceConfig);
        };

        updateFromMigration(id: number): ng.IHttpPromise<any> {
            return this.$http.get(`/api/advisor/updatefrommigration/${id}`);
        };

        // status is "open" (the default), "closed" or "all".
        getSalesforceOpenCases(filterByAdvisors: boolean = false, status: string = "open"): ng.IHttpPromise<domains.ISalesforceCaseResult> {
            return this.$http.get(`/api/advisor/getopencases/${filterByAdvisors}?status=${status}`);
        };

        // Cases Salesforce holds against the household itself, which is what its Related tab lists.
        getSalesforceHouseholdCases(householdId: number, status: string = "open"): ng.IHttpPromise<domains.ISalesforceCaseResult> {
            return this.$http.get(`/api/advisor/household/${householdId}/cases?status=${status}`);
        };

        getSalesforceCaseRecordTypes(): ng.IHttpPromise<domains.ISalesforceCaseRecordType[]> {
            return this.$http.get("/api/advisor/case/recordtypes");
        };

        getSalesforceCaseNewForm(recordTypeId: string): ng.IHttpPromise<domains.ISalesforceCaseNewFormResult> {
            return this.$http.get(`/api/advisor/case/newform/${recordTypeId}`);
        };

        // lookup is "contact", "user" or "household"; every match is a live Salesforce record.
        searchSalesforceCaseLookup(lookup: string, term: string): ng.IHttpPromise<domains.ISalesforceLookupResult[]> {
            return this.$http.get(`/api/advisor/case/lookup/${lookup}`, { params: { term: term } });
        };

        createSalesforceCase(salesforceCase: domains.ISalesforceCaseCreate): ng.IHttpPromise<domains.ISalesforceCaseCreateResult> {
            return this.$http.post("/api/advisor/case/create", salesforceCase);
        };

        // #region Links
        addLink(link: domains.ILink): ng.IHttpPromise<domains.ILink> {
            return this.$http.put("/api/advisor/addLink", link);
        };

        deleteLink(linkId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/advisor/deleteLink/${linkId}`);
        }
        //#endregion Links

        // #region Trusted Contacts
        getTrustedContactsForInvestor(investorId: number): ng.IHttpPromise<domains.ITrustedContact[]> {
            return this.$http.get(`api/advisor/gettrustedcontactsforinvestor/` + investorId);
        }

        saveInvestorTrustedContacts(investorId: number, model: domains.ITrustedContact[]): ng.IHttpPromise<{}> {
            return this.$http.post(`api/advisor/saveinvestortrustedcontacts/` + investorId, model);
        };
        // #endregion Trusted Contacts

        // #region Funding Components
        saveFundingComponents(accountId: number, model: domains.IAccountFundingComponent[]): ng.IHttpPromise<domains.IAccountFundingComponent[]> {
            return this.$http.post(`api/advisor/saveaccountfundingcomponents/` + accountId, model);
        }
        // #endregion Funding Components

        // #region MS Graph Integration
        msGraphIntegrationCheck(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/msgraphintegrationcheck`);
        };
        msGraphIntegrationRequest(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/msgraphintegrationrequest`);
        };
        msGraphIntegrationResponse(code: string, state: string): ng.IHttpPromise<{}> {
            return this.$http
                .post("api/integration/msgraphintegrationresponse",
                    {
                        item1: code,
                        item2: state
                    });
        };

        getAdvisorGraphUserInfo(): ng.IHttpPromise<Object> {
            return this.$http.get("api/advisor/getadvisorgraphuserinfo");
        }

        getAdvisor2wCalendar(): ng.IHttpPromise<Object> {
            return this.$http.get("api/advisor/getadvisor2wcalendar");
        }

        getAdvisorCalendarEvents(startDate?: Date, endDate?: Date): ng.IHttpPromise<Array<domains.IMeeting>> {
            if (startDate == undefined) {
                startDate = new Date(Date.now());
            }

            if (endDate == undefined) {
                endDate = new Date(startDate);
                endDate.setDate(endDate.getDate() + 14);
            }

            var utcStartDate = startDate.toUTCString();
            var utcEndDate = endDate.toUTCString();

            return this.$http.get(`api/advisor/getadvisorcalendarevents/?startDate=${utcStartDate}&endDate=${utcEndDate}`);
        }

        getAdvisorAvailableMeetingTimes(meetingId?: string, startDate?: Date, endDate?: Date): ng.IHttpPromise<Array<domains.IMeetingAvailabilityDuration>> {
            if (startDate == undefined) {
                startDate = new Date(Date.now());
            }

            if (endDate == undefined) {
                endDate = new Date(startDate);
                endDate.setDate(endDate.getDate() + 30);
            }

            var utcStartDate = startDate.toUTCString();
            var utcEndDate = endDate.toUTCString();

            var today = new Date();
            var jan = new Date(today.getFullYear(), 0, 1);
            var jul = new Date(today.getFullYear(), 6, 1);
            var isDSTObservered = jul.getTimezoneOffset() < jan.getTimezoneOffset();
            var std = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
            var isStartDST = isDSTObservered && startDate.getTimezoneOffset() < std;
            var isEndDST = isDSTObservered && endDate.getTimezoneOffset() < std;

            return this.$http.get(`api/advisor/getadvisoravailablemeetingtimes/?startDate=${utcStartDate}&isStartDST=${isStartDST}&endDate=${utcEndDate}&isEndDST=${isEndDST}&isDSTObservered=${isDSTObservered}&meetingId=${meetingId}`);
        }

        getAdvisorCalenders(): ng.IPromise<any> {
            var def = this.$q.defer();

            this.$http.get(`api/advisor/getadvisorcalendars/`).then(response => {
                return def.resolve({
                    success: true,
                    data: response.data
                })
            }, error => {
                return def.resolve({
                    success: false,
                    data: error
                })
            });

            return <ng.IPromise<any>>def.promise;
        }
        // #endregion Outlook Integration


        updateInvestorUsernameToMatchEmail(investorId: number): ng.IHttpPromise<any> {
            return this.$http.get(`api/advisor/updateinvestorusernametomatchemail/` + investorId);
        }

        // #region Advisor CRM Mappings
        getAdvisorCrms(advisorId: number): ng.IHttpPromise<domains.IAdvisorCrmViewModel[]> {
            return this.$http.get(`api/advisor/crm/${advisorId}`);
        }

        saveAdvisorCrm(model: domains.IAdvisorCrmViewModel): ng.IHttpPromise<domains.IAdvisorCrmViewModel> {
            return this.$http.post(`api/advisor/crm`, model);
        }

        deleteAdvisorCrm(id: number): ng.IHttpPromise<void> {
            return this.$http.delete(`api/advisor/crm/${id}`);
        }
        // #endregion Advisor CRM Mappings


    }
    angular.module(Constants.ADVOP_SERVICES).service(`advisorService`, AdvisorService);
} 
